var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{attrs:{"readonly":_vm.disabled,"rows":_vm.disabled == true ? 5 : 2,"auto-grow":""},model:{value:(_vm.dAnswer),callback:function ($$v) {_vm.dAnswer=$$v},expression:"dAnswer"}})}
var staticRenderFns = []

export { render, staticRenderFns }